import {
    CREATEMEDICINCECATEGORY,
    GETMEDICINCECATEGORY,
    UPDATEMEDICINECATEGORY,
    DELETEMEDICINCECATEGORY,
    CREATESUPPLIER,
    GETSUPPLIER,
    UPDATESUPPLIER,
    DELETESUPPLIER,
    CREATEDOSEUNIT,
    GETDOSEUNIT,
    UPDATEDOSEUNIT,
    DELETEDOSEUNIT,
    UPDATEMEDICINCEDOSAGE,
    DELETEMEDICINCEDOSAGE,
    GETMEDICINCEDOSAGE,
    CREATEMEDICINCEDOSAGE,
    CREATEDOSEINTERVAL,
    GETDOSEINTERVAL,
    UPDATEDOSEINTERVAL,
    DELETEDOSEINTERVAL,
    CREATEDOSEDURATION,
    GETDOSEDURATION,
    UPDATEDOSEDURATION,
    DELETEDOSEDURATION,
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEMEDICINCECATEGORY:
            return {
                ...state,
                medicincecatrgorySaveStatus: action.payload.success,
            }
        case GETMEDICINCECATEGORY:
                return {
                        ...state,
                        medicinecategoryList: action.payload.data,
                        }
        case UPDATEMEDICINECATEGORY:
                return {
                        ...state,
                        medicincecategoryUpdateStatus: action.payload.success,
                        }   

        case DELETEMEDICINCECATEGORY:
                 return {
                     ...state,
                     medicincecategoryDeleteStatus: action.payload.success,
                        } 
        case CREATESUPPLIER:
            return {
                ...state,
                supplierSaveStatus: action.payload.success,
            }
        case GETSUPPLIER:
                return {
                        ...state,
                        supplierList: action.payload.data,
                        }
        case UPDATESUPPLIER:
                return {
                        ...state,
                        supplierUpdateStatus: action.payload.success,
                        }   

        case DELETESUPPLIER:
                 return {
                     ...state,
                     supplierDeleteStatus: action.payload.success,
                        } 
        case CREATEDOSEUNIT:
            return {
                ...state,
                unitSaveStatus: action.payload.success,
            }
        case GETDOSEUNIT:
                return {
                        ...state,
                        unitList: action.payload.data,
                        }
        case UPDATEDOSEUNIT:
                return {
                        ...state,
                        unitUpdateStatus: action.payload.success,
                        }   

        case DELETEDOSEUNIT:
                 return {
                     ...state,
                     unitDeleteStatus: action.payload.success,
                 }
        case CREATEMEDICINCEDOSAGE:
                return {
                    ...state,
                    medicincedosageSaveStatus: action.payload.success,
                        }
        case GETMEDICINCEDOSAGE:
                return {
                        ...state,
                        medicincedosageList: action.payload.data,
                        }
        case UPDATEMEDICINCEDOSAGE:
                return {
                        ...state,
                        medicincedosageUpdateStatus: action.payload.success,
                        }   
            
        case DELETEMEDICINCEDOSAGE:
                return {
                        ...state,
                        medicincedosageDeleteStatus: action.payload.success,
                        } 
        case CREATEDOSEINTERVAL:
                return {
                ...state,
                doseintervalSaveStatus: action.payload.success,
                   }
        case GETDOSEINTERVAL:
                return {
                        ...state,
                        doseintervalList: action.payload.data,
                        }
        case UPDATEDOSEINTERVAL:
                return {
                        ...state,
                        doseintervalUpdateStatus: action.payload.success,
                        }   

        case DELETEDOSEINTERVAL:
                 return {
                     ...state,
                     doseintervalDeleteStatus: action.payload.success,
                        }
        case CREATEDOSEDURATION:
                return {
                ...state,
                dosedurationSaveStatus: action.payload.success,
                   }
        case GETDOSEDURATION:
                return {
                        ...state,
                        dosedurationList: action.payload.data,
                        }
        case UPDATEDOSEDURATION:
                return {
                        ...state,
                        dosedurationUpdateStatus: action.payload.success,
                        }   

        case DELETEDOSEDURATION:
                 return {
                     ...state,
                     dosedurationDeleteStatus: action.payload.success,
                        }
                        default:
                            return state
                                  }
                             }